import { inject, Injectable } from '@angular/core';
import { ToastButton, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ErrorMessage } from '../helpers/formUtils.helper';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AbstractApi {
  http = inject(HttpClient);
  backend = environment.backendUri;

  constructor() {}
}
